/**
 * type handle
 */
export default class JassHandle {
  handleId = -1;
}
